export const LevelSkillKeys = {
  allLevelSkills: ['LevelSkills'] as const,
  listLevelSkills: () =>
    [...LevelSkillKeys.allLevelSkills, 'LevelSkills'] as const,
  listLevelSkill: () => [...LevelSkillKeys.listLevelSkills(), {}] as const,
}
